export default "/images/vendor/flag-icon-css/flags/1x1/gl.svg?68756f324152d0ada90caf6c823f6f86";